import { React } from 'react'

import { useGetPaginatedCronogramaMutation } from '../../../store/api/endpoints/cronogramaApiSlice'

import HeaderVista from '../../elementos/HeaderVista'
import TablaPaginada from '../../elementos/TablaPaginada'


import Button from '@mui/material/Button'
import { Breadcrumbs, Typography } from '@mui/material'

import AddIcon from '@mui/icons-material/Add'
import EventIcon from '@mui/icons-material/Event'
import { Link } from 'react-router-dom'

import CreateIcon from '@mui/icons-material/Create'
import DeleteIcon from '@mui/icons-material/Delete'

export default function Cronograma() {

    const thead = []
    thead.push({ label: "Imagen", align: "center", ordenable: false })
    thead.push({ label: "Fecha y Hora", align: "center", ordenable: true })
    thead.push({ label: "Título", align: "left", ordenable: true })
    thead.push({ label: "Modalidad", align: "left", ordenable: false })
    thead.push({ label: "Acciones", align: "center", ordenable: false })

    const tbody = []
    tbody.push({ tipo: "img", valor: "imagen" })
    tbody.push({ tipo: "fechahora", valor: "fechayhora" })
    tbody.push({ tipo: "texto", valor: "titulo" })
    tbody.push({ tipo: "texto", valor: "modalidad" })
    let botones = []
    botones.push({ color: "primary", icono: <CreateIcon />, ruta: "/cronograma/editar/", valor: '_id' })
    botones.push({ color: "error", icono: <DeleteIcon />, ruta: "/cronograma/eliminar/", valor: '_id' })
    tbody.push({ tipo: "botones", valor: botones })


    return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Typography color="text.primary">Cronogramas</Typography>
                    </Breadcrumbs>
                }
                icon={<EventIcon />}
                end={<Link to="/cronograma/crear">
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                    >
                        Nuevo
                    </Button>
                </Link>}
            />
            <TablaPaginada
                api={useGetPaginatedCronogramaMutation}
                thead={thead}
                tbody={tbody}
                orderDefault={[1, 1]}
            />
        </>
    )

}